/**
 * Renders the preloader
 */
const Loader = () => {
  return (
    <div id="loader-page">
      <div className="preloader">
        <div className="status">
          <div
            className="loading-text text-center"
          >
            Loading...
          </div>
        </div>
      </div>
    </div>
  );
};

export default Loader;
